import React from 'react'
import { Icon, IconName } from '@unbounded/unbounded-components'
import { Footer, Header } from '~layout'
import Arrow from '~routes/TokensPage/Arrow'
import BalanceSettings from '~routes/TokensPage/BalanceSettings/BalanceSettings'
import * as Styled from './TokensPage.styles'

const TokensPage: React.FC = () => (
  <Styled.Page>
    <Header />
    <Styled.Header>
      <Styled.LogoContainer>
        <Icon name={IconName.brand_ethereum} />
      </Styled.LogoContainer>
      <Styled.ArrowContainer>
        <Arrow />
        <Styled.ArrowTitle>Manage your BOUND tokens</Styled.ArrowTitle>
      </Styled.ArrowContainer>
      <Styled.LogoContainer>
        <Icon name={IconName.brand_unbounded} />
      </Styled.LogoContainer>
    </Styled.Header>
    <Styled.ContrastSectionsOpener />
    <Styled.ContentWrap>
      <Styled.Content>
        <BalanceSettings />
      </Styled.Content>
    </Styled.ContentWrap>
    <Footer />
  </Styled.Page>
)

export default TokensPage
